<div class="outermost">

  <div class="top">
    <div class="flexrow header-container" style="justify-content: space-between;">
      <mat-icon class="cv_icon" svgIcon="carteVitale-icon"></mat-icon>
      <div class="daydate">{{ util.getFormattedDate() }}</div>
    </div>
  </div>

  @if (dialogdata.isTokenExpired) {
    <div class="">Scanner l'ApCV du patient</div>
  }

  <div class="middle">
    @if (!errormsg && !empreinteCVInserted && individuApCVs.length === 0 && countdown === undefined && !showHidInput && !scanSuccess) {
      <div class="buttonbar" style="display: flex; justify-content: space-between;">
        <div (click)="onQRClick($event)" class="apcvdiv" title="ApCV QR Code (USB)">
          <img src="assets/icons/apcv.png" class="apcvimg" alt="ApCV QR Code (USB)">
          <div class="apcvlabel">QR Code<br>(USB)</div>
        </div>
        <div (click)="onQRHIDClick($event)" class="apcvdiv" title="ApCV QR Code (HID)">
          <img src="assets/icons/apcv.png" class="apcvimg" alt="ApCV QR Code (HID)">
          <div class="apcvlabel">QR Code<br>(HID)</div>
        </div>
        <div (click)="onNFCClick($event)" class="apcvdiv" title="ApCV NFC">
          <img src="assets/icons/apcv.png" class="apcvimg" alt="ApCV NFC">
          <div class="apcvlabel">NFC</div>
        </div>
      </div>
    }

    @if (showHidInput) {
      <div class="scanner-container">
        <p>Veuillez scanner le QR Code ApCV...</p>
        <textarea
          #hid
          id="hid"
          (keydown.enter)="onHidScannerInput($any($event))"
          placeholder="Scan en cours..."
          class="hidden-scan-area">
        </textarea>
      </div>
    }

    @if (!loadingmsg && empreinteCVInserted && individuApCVs.length === 0) {
      <fieldset>
        <legend>Bénéficiaires en Carte Vitale</legend>
        @for (b of empreinteCVInserted.beneficiaire; track b; let index = $index) {
          <!-- Recipients loop -->
          <div>
            <button mat-button (click)="onRecipientClick($event, index, dao.constants.MODE_FSE_CV)" (mouseover)="onMouseOver(index)" (mouseout)="onMouseOut(index)">{{ getBeneficiaire(index) }}</button>
          </div>
        }
      </fieldset>
    }

    @if (!loadingmsg && individuApCVs.length>0) {
      <fieldset>
        <legend>Bénéficiaires ApCV</legend>
        @for (b of individuApCVs; track b; let index = $index) {
          <!-- Individus loop -->
          <div>
            <button mat-button (click)="onRecipientClick($event, index, apCvMode!)">{{ getBeneficiaire(index) }}</button>
          </div>
        }
        <div style="font-style: italic; font-size: small; font-weight: 100; margin-top: 10px;">Nom d'usage entre parenthèses</div>
      </fieldset>
    }

    @if (!errormsg && loadingmsg) {
      <div class="loadingdiv">  <!-- Initial CV reading/Loading -->
        <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" stroke="#3F51B5">
          <g fill="none" fill-rule="evenodd">
            <g transform="translate(1 1)" stroke-width="2">
              <circle stroke-opacity=".5" cx="22" cy="22" r="22"/>
              <path d="M22 0c12.15 0 22 9.85 22 22">
                <animateTransform attributeName="transform" type="rotate" from="0 22 22" to="360 22 22" dur="1s" repeatCount="indefinite"/>
              </path>
            </g>
          </g>
        </svg>
        <div class="loading" style="white-space: pre-line; text-align: center;">
          {{ loadingmsg }}
        </div>
      </div>
    }

    @if (countdown !== undefined) {
      <div class="countdown" style="text-align: center; font-weight: 500; margin: 10px;">
        @if (apCvMode === dao.constants.MODE_FSE_APCV_QR) {
          <p style="margin: 10px; font-size: larger;">Présenter le QR Code ApCV</p>
        }
        @if (apCvMode === dao.constants.MODE_FSE_APCV_NFC) {
          <p style="margin: 10px; font-size: larger;">Poser le smartphone sur le lecteur NFC</p>
        }
        <p>Temps restant : {{ countdown }}s</p>
      </div>
    }

    <!-- Snan is a success. Show a green tick -->
    @if (scanSuccess && individuApCVs.length === 0 && !errormsg) {
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 20px;">
        <svg width="128" height="128" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg><br/>
        <p>Si la page FSE ne s'ouvre pas, consulter la fenêtre AreaFSE</p>
      </div>
    }
  </div>

  <div class="bottom">
    @if (apCvMode !== dao.constants.MODE_FSE_CV && !dialogdata.isTokenExpired) {
      <div>
        <button mat-button (click)="onGetCtxApCV()">Restituer Ctx ApCV</button>
        <button mat-button (click)="onDelCtxApCV()">Détruire Ctx ApCV</button>
      </div>
    }

    @if (errormsg && !loadingmsg) {
      <div class="error">
        {{ errormsg }}
      </div>
    }
    @if (warningmsg && !loadingmsg) {
      <div class="warning">
        {{ warningmsg }}
      </div>
    }

    <div class="bottombuttonbar">
      <button mat-flat-button (click)="onClose()">Annuler</button>
      @if (!dialogdata.isTokenExpired) {
        <button mat-flat-button (click)="onNOCVClick($event)">Patient sans carte</button>
      }
    </div>
  </div>

</div>